import { Injectable } from '@angular/core';
import { SnackAlertService } from './snack-alert.service';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HandlerSnackbarService {
  constructor(private readonly alertService: SnackAlertService) {}

  handlerErrorSubscribe(error: any) {
    return throwError(() => {
      console.error(error);
      this.viewUserClosingMessage(
        error.error?.error?.message ||
          error.error?.message ||
          error?.message ||
          'System Error',
        'error-snackbar'
      );
    });
  }

  viewUserClosingMessage(smg: string, type: string) {
    this.alertService.openSnackBar(smg, type, 3000, 'Chiudi');
  }

  viewUserMessage(smg: string = 'Operazione in corso...', type?: string) {
    type
      ? this.alertService.openSnackBar(smg, type)
      : this.alertService.openSnackBar(smg);
  }

  viewErrorMessageNewRequest(error: any, formData: FormData) {
    this.alertService.openErrorNewRequest(
      error.error?.error?.message ||
        error.error?.message ||
        error?.message ||
        'System Error',
      formData
    );
    return throwError(() => {
      console.error(error);
    });
  }
}
